import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-search-filter-chip-range-date',
  templateUrl: './search-filter-chip-range-date.component.html',
  styleUrl: './search-filter-chip-range-date.component.scss',
})
export class SearchFilterChipRangeDateComponent {
  @Input() name!: string;
  @Output() emitFilter = new EventEmitter<any>();

  range: { start: Date | null; end: Date | null } = { start: null, end: null };
  selectingStartDate = true;

  dateSelected(date: Date): void {
    if (this.selectingStartDate) {
      this.range.start = date;
      this.range.end = null;
    } else {
      this.range.end = date;
      if (
        this.range.start &&
        this.range.end &&
        this.range.start > this.range.end
      ) {
        const temp = this.range.start;
        this.range.start = this.range.end;
        this.range.end = temp;
      }
    }

    this.selectingStartDate = !this.selectingStartDate;

    if (this.selectingStartDate) {
      this.emitFilter.emit(
        `${new Date(this.range.start!).toISOString()},${new Date(this.range.end!).toISOString()}`
      );
    }
  }

  clearSelectedRange(): void {
    this.range = { start: null, end: null };
    this.selectingStartDate = true;
    this.emitFilter.emit(null);
  }
}
